import { Classes } from '@blueprintjs/core'
import * as React from 'react'
import { UprightStyle } from '../types'

const style: UprightStyle = {
  row: { marginBottom: 0 }
}

interface Props {
  columnCount: number
}

export const LoadingRow: React.FC<Props> = props => (
  <tr>
    {[...Array(props.columnCount)].fill(
      <td>
        <p style={style.row} className={Classes.SKELETON}>
          -
        </p>
      </td>
    )}
  </tr>
)
